import { ApiClient } from "./clients";
import { LenderType } from "./enums/LenderType";

export interface BorrowerRegistrationInput {
  readonly email: string;
  readonly password: string;
  readonly companyId: string;
  readonly companyContactPerson: string;
  readonly companyPhone: string;
  readonly loanAmount: number;
  readonly loanObjectType: string;
  readonly loanObjectLocation: string;
  readonly referrerCode?: string;
}

export interface LenderRegistrationInput {
  readonly name: string;
  readonly email: string;
  readonly password: string;
  readonly type: LenderType;
  readonly referrerCode?: string;
  readonly ymClientId?: string;
}

export interface RegisteredUser {
  readonly uuid: string;
  readonly email: string;
}

export class RegistrationManager {
  constructor(private readonly apiClient: ApiClient) {}

  registerBorrower(input: BorrowerRegistrationInput): Promise<RegisteredUser> {
    return this.apiClient.post("/borrower", input);
  }

  registerLender(input: LenderRegistrationInput): Promise<RegisteredUser> {
    return this.apiClient.post("/lender", input);
  }
}
